import { connect } from 'react-redux'
import { RootState } from '_store'

export const userConnector = connect(
    (state: RootState) => ({ user: state.system.user }),
)
